import { useEffect, useState } from 'react'
import { functions } from '../firebase'
import { forEach, keys } from 'lodash'

const prepareBoard = (inData) => {
  const board = {}
  forEach(inData, record => {
    if (!board[record.score]) {
      board[record.score] = []
    }
    board[record.score].push(record.userName)
  })

  const arrBoard = []

  forEach(keys(board), scoreKey => {
    arrBoard.push({ score: scoreKey, users: board[scoreKey] })
  })

  return arrBoard.sort((a, b) => a > b ? 1 : -1)
}

const useLeaderboardScores = ({ postId }) => {
  const [loading, setLoading] = useState(true)
  const [leaders, setLeaders] = useState()
  const [voteCount, setVoteCount] = useState()
  const [error, setError] = useState()

  useEffect(() => {
    setLoading(true)

    functions.getPostUserScores({ postId }).then((results) => {
      setLeaders(prepareBoard(results.data))
      setVoteCount(results.data.length)
      setLoading(false)
    }).catch((error) => {
      console.log(error)
      setError('Error loading leaderboard')
      setLoading(false)
    })
  }, [postId])

  return {
    leaders,
    voteCount,
    loading,
    error
  }
}

export default useLeaderboardScores
